(function () {
    'use strict';

    angular
        .module('elogbooks.common.jobs')
        .controller('JobComplianceDocumentsController', JobComplianceDocumentsController);

    JobComplianceDocumentsController.$inject = [
        '$state',
        'complianceDocumentsResponse',
        'jobResponse',
        'apiClient',
        'userManager',
        'modulesService',
        'elbSettings',
        'elbDownloadService',
        'messenger',
        'complianceDocumentsResponseService'
    ];

    function JobComplianceDocumentsController(
        $state,
        complianceDocumentsResponse,
        jobResponse,
        apiClient,
        userManager,
        modulesService,
        elbSettings,
        elbDownloadService,
        messenger,
        complianceDocumentsResponseService
    ) {
        const vm = this;
        const isTenantRestricted = userManager.hasPermission('site_permission_tenant')
            || userManager.hasPermission('site_permission_tenant_plus');
        const meridianEnabled = modulesService.isEnabled('meridian');
        const complianceDocumentsEnabled = elbSettings.getSetting('general_meridian_compliance_documents_available', false).value === true;
        let liveResponseCanBeTopOnly = complianceDocumentsResponse.availableAtJobCreationDocuments
            && complianceDocumentsResponse.availableAtJobCreationDocuments.pending === true;

        vm.isAllowed = meridianEnabled && complianceDocumentsEnabled && !isTenantRestricted;

        if (!vm.isAllowed) {
            $state.go('^');
            return;
        }

        vm.availableAtJobCreationDocuments = [];
        vm.additionalLiveDocuments = [];
        vm.availableAtJobCreationDocumentsUpdatedAt = null;
        vm.additionalLiveDocumentsUpdatedAt = null;
        vm.availableAtJobCreationDocumentsMessage = null;
        vm.additionalLiveDocumentsMessage = null;
        vm.availableAtJobCreationDocumentsMessageParams = {};
        vm.additionalLiveDocumentsMessageParams = {};
        vm.liveLoading = false;
        vm.topLoading = false;

        vm.downloadDocument = function (document) {
            if (!document || !document.id) {
                return;
            }

            if (document.isDownloading) {
                return;
            }

            const fileName = 'compliance-document';
            let downloadPromise;

            document.isDownloading = true;
            downloadPromise = elbDownloadService.downloadUrl(document.getLink('download'), fileName);

            if (downloadPromise) {
                downloadPromise
                    .catch(function (errorResponse) {
                        const errorCode = resolveDownloadErrorCode(errorResponse);

                        if (errorCode) {
                            messenger.error('COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION', { code: errorCode });
                            return;
                        }

                        messenger.error('COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION_NO_CODE');
                    })
                    .finally(function () {
                        document.isDownloading = false;
                    });
            } else {
                document.isDownloading = false;
            }

            return downloadPromise;
        };

        applySection(complianceDocumentsResponse.availableAtJobCreationDocuments, 'availableAtJobCreationDocuments');
        applySection(complianceDocumentsResponse.additionalLiveDocuments, 'additionalLiveDocuments');

        fetchLiveAdditionalDocuments();

        function fetchLiveAdditionalDocuments() {
            const liveUrl = complianceDocumentsResponse.availableAtJobCreationDocuments
                && angular.isFunction(complianceDocumentsResponse.availableAtJobCreationDocuments.getLink)
                ? complianceDocumentsResponse.availableAtJobCreationDocuments.getLink('live')
                : null;
            const topSectionUrl = complianceDocumentsResponse.availableAtJobCreationDocuments
                && angular.isFunction(complianceDocumentsResponse.availableAtJobCreationDocuments.getLink)
                ? complianceDocumentsResponse.availableAtJobCreationDocuments.getLink('self')
                : null;
            const userKey = complianceDocumentsResponseService.resolveUserKey(userManager);
            const jobKey = complianceDocumentsResponseService.resolveJobKey(jobResponse);

            if (!liveUrl) {
                return;
            }

            const cachedLiveResponse = complianceDocumentsResponseService.getLive(userKey, jobKey);
            if (cachedLiveResponse) {
                applyLiveAdditionalDocuments(cachedLiveResponse);
                return;
            }

            vm.liveLoading = true;
            apiClient.get(liveUrl).then(function (response) {
                response = complianceDocumentsResponseService.normalize(
                    apiClient,
                    response,
                    liveResponseCanBeTopOnly
                );

                if (!response) {
                    applyLiveErrorResponse(apiClient.getLastError());
                    return;
                }

                if (response.error || isLiveRequestFailureMessage(response.message)) {
                    if (applyLiveErrorResponse(response)) {
                        if (shouldShowRequestErrorSnackbar(response)) {
                            messenger.error('REQUEST_ERROR');
                        }
                        return;
                    }
                }

                if (response.availableAtJobCreationDocuments) {
                    applyTopSection(response.availableAtJobCreationDocuments);
                    liveResponseCanBeTopOnly = false;

                    if (topSectionUrl && complianceDocumentsResponse.availableAtJobCreationDocuments
                        && complianceDocumentsResponse.availableAtJobCreationDocuments.pending === true
                        && response.availableAtJobCreationDocuments.message === 'COMPLIANCE_DOCUMENTS_NO_SITE_WITH_MATCHING_REFERENCE_FOUND') {
                        refreshAvailableAtJobCreationDocuments(topSectionUrl);
                    } else {
                        vm.topLoading = false;
                    }
                } else {
                    vm.topLoading = false;
                }

                var additionalSection = resolveAdditionalSection(response);
                if (!additionalSection) {
                    if (response.availableAtJobCreationDocuments && !response.additionalLiveDocuments) {
                        return;
                    }
                    if (!applyLiveErrorResponse(apiClient.getLastError())) {
                        messenger.error('REQUEST_ERROR');
                    }
                    return;
                }

                if (shouldCacheLiveResponse(additionalSection)) {
                    complianceDocumentsResponseService.setLive(userKey, jobKey, additionalSection);
                }
                applyLiveAdditionalDocuments(additionalSection);
            }).catch(function (errorResponse) {
                if (!applyLiveErrorResponse(errorResponse)) {
                    messenger.error('REQUEST_ERROR');
                }
            }).finally(function () {
                vm.liveLoading = false;
            });
        }

        function refreshAvailableAtJobCreationDocuments(url) {
            vm.topLoading = true;

            apiClient.get(url, null, false).then(function (response) {
                response = complianceDocumentsResponseService.normalize(apiClient, response);

                if (!response || !response.availableAtJobCreationDocuments) {
                    return;
                }

                applyTopSection(response.availableAtJobCreationDocuments);
            }).finally(function () {
                vm.topLoading = false;
            });
        }

        function shouldCacheLiveResponse(response) {
            if (!response) {
                return false;
            }

            if (angular.isNumber(response.status) && response.status >= 400) {
                return false;
            }

            if (response.pending === true) {
                return false;
            }

            return response.message !== 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION';
        }

        function applyLiveAdditionalDocuments(response) {
            applySection(response, 'additionalLiveDocuments');
        }

        function resolveAdditionalSection(response) {
            if (!response) {
                return null;
            }

            if (response.availableAtJobCreationDocuments
                && !response.additionalLiveDocuments
                && response.availableAtJobCreationDocuments.message === 'COMPLIANCE_DOCUMENTS_NO_SITE_WITH_MATCHING_REFERENCE_FOUND'
            ) {
                return {
                    updatedAt: response.availableAtJobCreationDocuments.updatedAt || null,
                    documents: [],
                    message: 'COMPLIANCE_DOCUMENTS_NO_SITE_WITH_MATCHING_REFERENCE_FOUND',
                    messageParams: response.availableAtJobCreationDocuments.messageParams || {}
                };
            }

            if (response.availableAtJobCreationDocuments && !response.additionalLiveDocuments) {
                return {
                    updatedAt: response.availableAtJobCreationDocuments.updatedAt || null,
                    documents: [],
                    message: 'COMPLIANCE_DOCUMENTS_NO_ADDITIONAL_LIVE_FILES_FOUND',
                    messageParams: {}
                };
            }

            if (response.additionalLiveDocuments) {
                return response.additionalLiveDocuments;
            }

            return response;
        }

        function applyTopSection(section) {
            applySection(section, 'availableAtJobCreationDocuments');
        }

        function applyLiveErrorResponse(errorResponse) {
            const responseData = errorResponse && errorResponse.data ? errorResponse.data : errorResponse;
            const statusCode = errorResponse && angular.isNumber(errorResponse.status) ? errorResponse.status : null;
            let message = responseData && responseData.message ? responseData.message : null;
            let messageParams = responseData && responseData.messageParams ? responseData.messageParams : {};

            if (!message && statusCode && statusCode >= 400) {
                message = 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION';
                messageParams = { code: statusCode };
            }

            if (!message) {
                return false;
            }

            applySection({
                updatedAt: responseData.updatedAt || null,
                documents: [],
                message: message,
                messageParams: messageParams
            }, 'additionalLiveDocuments');

            return true;
        }

        function shouldShowRequestErrorSnackbar(responseLike) {
            const responseData = responseLike && responseLike.data ? responseLike.data : responseLike;
            const message = responseData && responseData.message ? responseData.message : null;

            return message !== 'COMPLIANCE_DOCUMENTS_NO_SITE_WITH_MATCHING_REFERENCE_FOUND';
        }

        function isLiveRequestFailureMessage(message) {
            return message === 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION';
        }

        function normalizeUnableConnectionMessage(message, messageParams) {
            const hasErrorCode = messageParams && !!messageParams.code;

            if (
                message === 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION'
                && !hasErrorCode
            ) {
                return 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION_NO_CODE';
            }

            return message;
        }

        function applySection(section, keyPrefix) {
            const normalizedSection = section || {};
            const params = normalizedSection.messageParams || {};

            vm[keyPrefix + 'UpdatedAt'] = normalizedSection.updatedAt ? new Date(normalizedSection.updatedAt) : null;
            vm[keyPrefix + 'MessageParams'] = params;
            vm[keyPrefix + 'Message'] = normalizeUnableConnectionMessage(
                normalizedSection.message || null,
                params
            );
            vm[keyPrefix] = complianceDocumentsResponseService.toResponseDataDocuments(
                apiClient,
                normalizedSection.documents
            );

            synchronizeNoSiteMessageAcrossTables();
        }

        function synchronizeNoSiteMessageAcrossTables() {
            const noSiteMessage = 'COMPLIANCE_DOCUMENTS_NO_SITE_WITH_MATCHING_REFERENCE_FOUND';
            const unableConnectionMessage = 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION';
            const unableConnectionNoCodeMessage = 'COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION_NO_CODE';
            const isTopEmpty = !angular.isArray(vm.availableAtJobCreationDocuments) || vm.availableAtJobCreationDocuments.length === 0;
            const isBottomNoSite = vm.additionalLiveDocumentsMessage === noSiteMessage;
            const isBottomUnableConnection = vm.additionalLiveDocumentsMessage === unableConnectionMessage;
            const isBottomUnableConnectionNoCode = vm.additionalLiveDocumentsMessage === unableConnectionNoCodeMessage;

            if (!isTopEmpty || (!isBottomNoSite && !isBottomUnableConnection && !isBottomUnableConnectionNoCode)) {
                return;
            }

            vm.availableAtJobCreationDocumentsMessage = vm.additionalLiveDocumentsMessage;
            vm.availableAtJobCreationDocumentsMessageParams = vm.additionalLiveDocumentsMessageParams || {};
            vm.availableAtJobCreationDocumentsUpdatedAt = vm.additionalLiveDocumentsUpdatedAt;
        }

        function resolveDownloadErrorCode(errorResponse) {
            const payload = extractDownloadErrorPayload(errorResponse);

            if (!angular.isArray(payload) || payload.length === 0) {
                return null;
            }

            const firstError = payload[0];

            if (!firstError || !firstError.data || !firstError.data.code) {
                return null;
            }

            return firstError.data.code;
        }

        function extractDownloadErrorPayload(errorResponse) {
            if (!errorResponse || !errorResponse.data) {
                return null;
            }

            if (angular.isArray(errorResponse.data)) {
                return errorResponse.data;
            }

            if (!(errorResponse.data instanceof ArrayBuffer)) {
                return null;
            }

            try {
                if (typeof TextDecoder !== 'undefined') {
                    const payloadText = new TextDecoder('utf-8').decode(new Uint8Array(errorResponse.data));
                    return payloadText ? JSON.parse(payloadText) : null;
                }
            } catch(e) {
            }

            return null;
        }
    }
})();
